"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../../schema");
const igG = schema_1.Schema.number()
    .expiration(15552000)
    .unit("U/mL")
    .precision(1)
    .min(0)
    .max(200)
    .interpretation({ vocab: "ltx", code: "anti_cardiolipin_at_igg" })
    .tag({ vocab: "snomed", code: "69480007" })
    .tag({ vocab: "loinc", code: "2324-2" });
const igM = schema_1.Schema.number()
    .optional()
    .expiration(15552000)
    .unit("U/mL")
    .precision(1)
    .min(0)
    .max(200)
    .interpretation({ vocab: "ltx", code: "anti_cardiolipin_at_igm" })
    .tag({ vocab: "snomed", code: "69480007" })
    .tag({ vocab: "loinc", code: "2324-2" });
const igA = schema_1.Schema.number()
    .optional()
    .expiration(15552000)
    .unit("U/mL")
    .precision(1)
    .interpretation({ vocab: "ltx", code: "anti_cardiolipin_at_iga" })
    .tag({ vocab: "snomed", code: "69480007" })
    .tag({ vocab: "loinc", code: "2324-2" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ IgG: igG, IgM: igM, IgA: igA })
    .interpretation({ vocab: "ltx", code: "anti_cardiolipin_at" })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "396550006" })
    .tag({ vocab: "snomed", code: "26958001" })
    .tag({ vocab: "loinc", code: "24325-3" });
